import React from "react";
import ClipLoader from "react-spinners/ClipLoader";
import "./Loading.scss";

const Loading = () => {
    return (
        <div className="loaderWrapper">
            <ClipLoader className="login-clip-loader" color={"blue"} />
        </div>

    );
};

export default Loading;
